// @flow

import * as React from 'react';
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import { useParams } from 'react-router-dom';

import i18n from 'app/common/i18n';
import { singleDwelling, clear } from 'app/redux/modules/organizations';

import StepPreview from './StepPreview';
import { Mutation } from '../common/Mutation';
import { EXTEND_DWELLING } from './table';

class Update extends React.Component {
  static fetchData({ dispatch, params }) {
    if (params && params.uuid) {
      return dispatch(singleDwelling(params.uuid));
    }

    return dispatch(clear());
  }

  constructor(props) {
    super(props);

    this.state = {
      dwelling: props.dwelling
    };
  }

  componentDidMount() {
    const { params = {}, dwelling } = this.props;
    const uuid = params.uuid;
  
    if (!uuid) {
      this.props.clear();
      return;
    }
  
    if (!dwelling || dwelling.uuid !== uuid) {
      this.props.clear();
      this.props.singleDwelling(uuid);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.dwelling &&
      this.props.dwelling !== prevProps.dwelling &&
      this.props.dwelling !== this.state.dwelling
    ) {
      this.setState({ dwelling: this.props.dwelling });
    }
  }

  updateDwelling = (name, value) => {
    this.setState(({ dwelling }) => ({
      dwelling: {
        ...(dwelling || {}),
        [name]: value
      }
    }));
  };

  render() {
    const { params = {}, user } = this.props;
    const uuid = params.uuid;
    const dwelling = this.state.dwelling || this.props.dwelling;
  
    if (!uuid || !dwelling || !dwelling.location) {
      return null;
    }
  
    // Important: prevent showing stale Redux dwelling
    if (dwelling.uuid !== uuid) {
      return null;
    }
  
    return (
      <Mutation mutation={EXTEND_DWELLING}>
        {(mutate) => (
          <StepPreview
            key={uuid}
            paymentTable
            setValue={this.updateDwelling}
            dwelling={fromJS(dwelling)}
            onExtend={mutate}
            user={user}
          />
        )}
      </Mutation>
    );
  }
}

function UpdateWithRouter(props) {
  const params = useParams();

  return <Update key={params.uuid || 'new'} {...props} params={params} />;
}

UpdateWithRouter.fetchData = Update.fetchData;

export default connect(
  ({ auth: { user }, org: { dwellings } }) => ({
    dwelling: dwellings.single,
    user
  }),
  {
    singleDwelling,
    clear
  }
)(i18n(UpdateWithRouter));